import { render, staticRenderFns } from "./App.vue?vue&type=template&id=0d19afc3&"
import script from "../static/js/china.js?vue&type=script&lang=js&"
export * from "../static/js/china.js?vue&type=script&lang=js&"
import style0 from "./App.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports